import Vue from 'vue'
import Router from 'vue-router'

import App from '@/App'
import CityCouncilDistrict from '@/views/CityCouncilDistrict'
import CityCouncilDistricts from '@/views/CityCouncilDistricts'
import CityCouncilDistrictRanks from '@/views/CityCouncilDistrictRanks'
import Collisions from '@/views/Collisions'
import Locations from '@/views/Locations'
import Neighborhood from '@/views/Neighborhood'
import Neighborhoods from '@/views/Neighborhoods'
import NeighborhoodRanks from '@/views/NeighborhoodRanks'
import Data from '@/views/about/Data'
import Story from '@/views/about/Story'
import Technology from '@/views/about/Technology'
import ToDo from '@/views/about/ToDo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {path: '/', redirect: { name: 'collisionsIndex' }},
    { name: 'collisionsIndex', path: '/collisions', component: Collisions },
    {
      name: 'collisions',
      path: '/collisions/sd/:sd/ed/:ed/m/:m/nelat/:nelat/nelng/:nelng/swlat/:swlat/swlng/:swlng',
      component: Collisions
    },
    { name: 'locationsIndex', path: '/locations', component: Locations },
    { name: 'locations', path: '/locations/lids/:lids', component: Locations },
    {
      path: '/districts/city',
      redirect: { name: 'districts' },
      component: App,
      children: [
        { name: 'cityCouncilDistrict', path: '/districts/city/id/:id', component: CityCouncilDistrict },
        { name: 'cityCouncilDistricts', path: '/districts/cities', component: CityCouncilDistricts },
        { name: 'cityCouncilDistrictRanksIndex', path: '/districts/city/ranks', component: CityCouncilDistrictRanks },
        { name: 'cityCouncilDistrictRanks', path: '/districts/city/ranks/sd/:sd/ed/:ed', component: CityCouncilDistrictRanks }
      ]
    },
    {
      path: '/neighborhood',
      redirect: { name: 'neighborhood' },
      component: App,
      children: [
        { name: 'neighborhood', path: '/neighborhood/:id', component: Neighborhood },
        { name: 'neighborhoods', path: '/neighborhoods', component: Neighborhoods },
        { name: 'neighborhoodRanksIndex', path: '/neighborhood/ranks', component: NeighborhoodRanks },
        { name: 'neighborhoodRanks', path: '/neighborhood/ranks/sd/:sd/ed/:ed', component: NeighborhoodRanks }
      ]
    },
    {
      path: '/about',
      redirect: { name: 'story' },
      component: App,
      children: [
        { name: 'story', path: 'story', component: Story },
        { name: 'technology', path: 'technology', component: Technology },
        { name: 'data', path: 'data', component: Data },
        { name: 'toDo', path: 'todo', component: ToDo }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js